export const genders = {
  MALE: "Hombre",
  FEMALE: "Mujer",
  NOT_SAY: "",
  OTHER: "Otro"
};
